import type {
    SiteAnalyticsDataRequest,
    SiteAnalyticsDataResult,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-scaffold.type';
import type {
    SiteAnalyticsPageDefinition,
    SiteAnalyticsPageDefinitionDeps,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-definition.type';
import {
    buildEventsScaffoldConfig,
    loadEventsTabData,
} from '@client/app/feature-modules/site-analytics/definitions/events-definition.utils';

const EVENTS_NAMES_CONFIG = buildEventsScaffoldConfig({
    tableKey: 'site-analytics-events-names',
    dataSource: 'eventsNames',
    exportCategory: 'event_names',
    tableCaptionKey: 'siteAnalytics.events.names.table.caption',
    primaryColumnHeaderKey: 'siteAnalytics.events.table.column.name',
    secondaryColumnHeaderKey: 'siteAnalytics.events.table.column.action',
    primarySortField: 'event_name',
});

const loadEventsNamesData = (
    request: SiteAnalyticsDataRequest,
    deps: SiteAnalyticsPageDefinitionDeps,
): Promise<SiteAnalyticsDataResult> => {
    return loadEventsTabData(
        request,
        deps,
        (domainId, params) => deps.statisticsEventsRepoService.getEventsNames(domainId, params),
        'event_actions',
    );
};

export const EVENTS_NAMES_DEFINITION: SiteAnalyticsPageDefinition = {
    key: 'eventsNames',
    config: EVENTS_NAMES_CONFIG,
    loadData: loadEventsNamesData,
};

export const EVENTS_NAMES_PAGE_CONFIG = EVENTS_NAMES_DEFINITION.config;
